module.exports = __webpack_public_path__ + "img/empty_chat.783c23dc.svg";